import { EgretLoadable } from 'egret';
import { authRoles } from '~/app/auth/authRoles';

const DeviceModels = EgretLoadable({
  loader: () => import('./index')
});

const DeviceModelsRoute = [
  {
    path: '/device-models',
    exact: true,
    component: DeviceModels,
    auth: authRoles.admin,
  }
];

export default DeviceModelsRoute;
